import {useContext, useState} from 'react'
import {BadgeProductsContext} from '../../context'
import MultiSelect from '../../../../components/MultiSelect/MultiSelect'
import Search from '../../../../components/Search'
import DeleteProductBadgeModal from '../modals/DeleteProductBadgeModal'

const BadgeProductsHeader = () => {
  const {
    brands,
    categories,
    checkedRows,
    onBrandFilterChange,
    onCategoryFilterChange,
    onSearch,
    filters,
    totalCount,
  } = useContext(BadgeProductsContext)

  // Local state for filters
  const [selectedBrands, setSelectedBrands] = useState<any[]>([])
  const [selectedCategories, setSelectedCategories] = useState<any[]>([])
  const [showDeleteModal, setShowDeleteModal] = useState(false)

  // Handlers for MultiSelect
  const handleBrandChange = (selected: any[]) => {
    setSelectedBrands(selected)
  }
  const handleCategoryChange = (selected: any[]) => {
    setSelectedCategories(selected)
  }

  // Apply filters
  const onClickApplyFilter = () => {
    onBrandFilterChange(selectedBrands)
    onCategoryFilterChange(selectedCategories)
  }

  // Reset filters
  const onResetFilters = () => {
    setSelectedBrands([])
    setSelectedCategories([])
    onBrandFilterChange([])
    onCategoryFilterChange([])
  }

  const isApplyDisabled = selectedBrands.length === 0 && selectedCategories.length === 0

  return (
    <>
      <div className='d-flex justify-content-between align-items-center mb-10'>
        <div className='d-flex align-items-center gap-5'>
          <Search
            onSearch={(value: string) => {
              onSearch(value)
            }}
          />
        </div>

        {showDeleteModal && (
          <DeleteProductBadgeModal
            products={checkedRows}
            onClose={() => setShowDeleteModal(false)}
          />
        )}
      </div>
      <div className='d-flex justify-content-between mb-10'>
        <div className='d-flex gap-5'>
          <MultiSelect
            id='brands-filter'
            label=''
            options={brands}
            valueKey='id'
            labelKey='name'
            className='w-175px'
            placeholder='Select Brands'
            handleSelected={handleBrandChange}
            selectedValues={selectedBrands}
          />
          <MultiSelect
            id='categories-filter'
            label=''
            options={categories}
            valueKey='id'
            labelKey='name'
            className='w-175px'
            placeholder='Select Categories'
            handleSelected={handleCategoryChange}
            selectedValues={selectedCategories}
          />
          <button
            className='btn btn-primary'
            onClick={onClickApplyFilter}
            disabled={isApplyDisabled}
          >
            Apply Filters
          </button>
          {(filters?.brand_id || filters?.category_id) && (
            <button type='button' className='btn btn-outline' onClick={onResetFilters}>
              Reset Filters
            </button>
          )}
        </div>
        <div className='d-flex gap-5'>
          {checkedRows?.length > 0 && (
            <div className='text-end'>
              <button className='btn btn-danger' onClick={() => setShowDeleteModal(true)}>
                Delete all
              </button>
            </div>
          )}
          <p className='mt-2 mb-0'>
            Total <strong>{totalCount}</strong> Products
          </p>
        </div>
      </div>
    </>
  )
}

export default BadgeProductsHeader
